import React from "react";
import "./LoadingOverlay.css";

function LoadingOverlay({ label = "Loading" }) {
  return (
    <div
      className="loading-overlay"
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <span className="loading-overlay__sr-only">{label}</span>
    </div>
  );
}

export default LoadingOverlay;
